<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>国企担当 专业守护：东进公司全力做好虫媒传染病防控工作</h2>
        <div id="meta_content">
          <span class="rich_b"> 东莞国资 </span>
          <span id="rich_c">
            <span>2025-10-21 20:44</span>
            广东
          </span>
        </div>
        <p>
          面对基孔肯亚热疫情防控的严峻挑战，<span style="color: #000; font-weight: 700"
            >市属国企广东东进有害生物防控技术有限公司</span
          >（以下简称“东进公司”）坚决扛起政治责任与社会担当，以“疫情为令，防控为责”，迅速响应、科学部署、全员行动，在这场守护城市公共卫生安全的战役中，展现了关键时刻听指挥、拉得出、顶得上、打得赢的过硬作风，以实际行动诠释了国有企业的初心使命。
        </p>
        <h3 style="font-weight: 700; font-size: 16px; color: #000">
          1.闻令而动，织密高效指挥“组织网”
        </h3>
        <p>
          东进公司作为全国少有的专业有害生物防控国有企业，也是东莞唯一的同时具备国家、省、市行业最高等级资质的企业。按照市国资委、东实集团党委的部署，东进公司第一时间将防控工作提升至最高优先级，成立专项工作领导小组，主动加强与疾控、卫健部门及各镇街属地政府的联动协同，制定科学精准的防控实施方案。依托国企特有的资源整合优势，公司快速精准调配人力、物力、财力，确保各项防控指令迅速落地，并为创新防控手段的应用提供了坚实支撑。
        </p>
        <img width="100%" :src="img[0]" alt="" />
        <h3 style="text-align: center; margin: 5px 0; color: #7f7f7f; font-size: 14px">
          东进公司联合大岭山镇开展消杀培训
        </h3>
        <h3 style="font-weight: 700; font-size: 16px; color: #000">
          2.冲锋在前，筑牢基层一线“防火墙”
        </h3>
        <p>
          7月28日，东进公司迅速组建“疫情防控支援突击队”，承担起我市12个镇街及多家重点单位的专业消杀重任。截至10月20日，累计投入防控人员5400人次，完成蚊虫消杀面积达1.3亿平方米(相当于18207个标准足球场)，构筑起坚实的物理屏障。同时，公司定向捐赠基层急需防护物资，并派出由国家二级有害生物防制技师领衔的专业队伍，深入一线提供技术指导与支援。
        </p>
        <img width="100%" :src="img[1]" alt="" />
        <h3 style="text-align: center; margin: 5px 0; color: #7f7f7f; font-size: 14px">
          东进公司赴基层一线开展专业消杀
        </h3>

        <p>
          与此同时，东进公司全体党员主动请战，组建“党员先锋队”，深入村、社区开展环境消杀、防疫宣传等志愿服务，让党旗在防控一线高高飘扬。
        </p>
        <img width="100%" :src="img[2]" alt="" />
        <h3 style="text-align: center; margin: 5px 0; color: #7f7f7f; font-size: 14px">
          市国资委机关党支部联合东进公司到结对帮扶的清溪镇长山头村开展爱国卫生运动
        </h3>
        <h3 style="font-weight: 700; font-size: 16px; color: #000">
          3.科技引领，打造立体精准“防控圈”
        </h3>
        <p>东进公司积极引入科技力量，创新防控模式，显著提升消杀效率与覆盖面。</p>
        <div style="margin-left: 40px; padding-left: 40px; border-left: 1px dashed #666">
          <h5 style="font-size: 16px">无人机精准作业</h5>
          <p>
            引入无人机搭载超低容量喷雾器，对社区楼顶、荒地、树林等人员难以触及的区域进行全覆盖、无死角药物喷洒，有效破解消杀盲区难题。
          </p>
          <img width="100%" :src="img[3]" alt="" />
          <h3 style="text-align: center; margin: 5px 0; color: #7f7f7f; font-size: 14px">
            东进公司利用无人机进行精准消杀
          </h3>
          <h5 style="font-size: 16px">空中巡查闭环管理</h5>
          <p>
            利用无人机高清摄像头进行空中巡查，精准定位积水点、垃圾堆积处等隐患区域，形成“空中监测预警、地面精准处置”的闭环管理机制，实现从源头控制风险。
          </p>
          <h5 style="font-size: 16px">数据赋能联防联控</h5>
          <p>
            与各服务单位建立长效联防联控机制，通过数据共享、联合巡检等方式，筑牢疫情反弹防线，确保防控成果持续巩固。
          </p>
        </div>
        <p>
          下来，东进公司将继续秉持“人民至上、生命至上”的理念，持续提升公共卫生应急响应与处置能力，在服务城市发展战略、保障人民健康安全中展现更大作为，为推进中国式现代化的东莞实践贡献国企力量。
        </p>

        <h3>我们还提供多元化服务</h3>
        <img width="100%" :src="img[4]" alt="" />
        <h3>扫码关注我们了解更多</h3>
        <div>
          <img :src="img[5]" alt="" />
        </div>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span>&nbsp;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News15' })"
            >高温下的坚守 防控中的担当：东...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span
          >
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: [
        require("@/assets/news16_1.jpg"),
        require("@/assets/news16_2.jpg"),
        require("@/assets/news16_3.jpg"),
        require("@/assets/news16_4.jpg"),

        require("@/assets/news8-4.png"),
        require("@/assets/news8-7.png"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.black {
  font-weight: 700;
}

.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-left: 2.6em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
